import * as THREE from "three";
import { Color } from "three";

export class Scene extends THREE.Scene {
  constructor() {
    super();
    this.tone = 0;
    this.hemi = null;
    this.ambient = null;
    this.applyTone(this.tone);
  }

  applyTone(toneIndex = 0) {
    this.tone = toneIndex % 3;

    // Remove prior lights before adding new ones
    if (this.hemi) this.remove(this.hemi);
    if (this.ambient) this.remove(this.ambient);

    if (this.tone === 1) {
      this.background = new THREE.Color("#be976d");
      this.fog = new THREE.FogExp2("#ceab85", 0.05);
      this.hemi = new THREE.HemisphereLight("#FAECCD", "#E7B0A8", 0.1);
      this.ambient = new THREE.AmbientLight("#8e5c38", 3);
    } else if (this.tone === 2) {
      this.background = new THREE.Color("#474e59");
      this.fog = new THREE.FogExp2("#3a4145", 0.04);
      this.hemi = new THREE.HemisphereLight("#FAECCD", "#E7B0A8", 0.5);
      this.ambient = new THREE.AmbientLight("#0f72ab", 1);
    } else {
      this.background = new THREE.Color("#e3dbd1");
      this.fog = new THREE.FogExp2("#f1eae2", 0.04);
      this.hemi = new THREE.HemisphereLight("#FAECCD", "#E7B0A8", 2);
      this.ambient = new THREE.AmbientLight("#4d4847ff", 1);
    }

    if (this.hemi) this.add(this.hemi);
    if (this.ambient) this.add(this.ambient);
  }
}
